import { laptop } from 'src/components/layout/MediaQueries/MediaQueries.styles';
import { textStyleCss } from 'src/theme/atlas';
import styled, { css } from 'styled-components';

export const StyledText = styled.span`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
`;

export const StyledTextBold = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  font-weight: 600;
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
`;

export const Title = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.headingH3)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
`;

export const Bottom = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;
export const SummaryContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

export const MetricsContainer = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  flex-direction: row;
`;

export const MetricsItem = styled.div`
  flex-basis: 240px;
  flex-grow: 0;

  ${laptop(css`
    flex-grow: 2;
  `)}
`;

export const BannersContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const TableSectionWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 400px;
`;

export const TableTopContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
